// extracted by mini-css-extract-plugin
export default {"buttons-holder":"WarningDialog_buttons-holder__mtW7I","content":"WarningDialog_content__BnQhF","description":"WarningDialog_description__x6HrN"};